import * as React from 'react';
import { IAdvantagesItemProps } from './content';
import { UIHeading2, UIText1 } from '@cian/ui-kit';

import * as styles from './styles.css';

export const AdvantagesItem: React.FC<IAdvantagesItemProps> = ({ iconUrl, title, description }) => {
  return (
    <div className={styles['item']}>
      <div className={styles['heading']}>
        <img src={iconUrl} alt={description} />

        <UIHeading2 color="black_100">{title}</UIHeading2>
      </div>

      <div>
        <UIText1>{description}</UIText1>
      </div>
    </div>
  );
};
